
import { defineComponent, PropType } from 'vue'

export interface RunError {
  level: number
  message?: string
  hmessage?: string
}

export default defineComponent({
  name: 'RunErrorBox',

  props: {
    errorsRendered: {
      type: Array as PropType<RunError[]>,
      default: () => []
    }
  },

  computed: {
    counts(): { error: number; warning: number; info: number } {
      return this.errorsRendered.reduce(
        (acc, e) => {
          if (e.level === 0) acc.error++
          else if (e.level === 1) acc.warning++
          else acc.info++
          return acc
        },
        { error: 0, warning: 0, info: 0 }
      )
    }
  },

  methods: {
    getLabelType(level: number): string {
      const map: Record<number, string> = { 0: 'cherry', 1: 'amber', 2: 'neutral' }
      return map[level] ?? 'neutral'
    },
    getLabelText(level: number): string {
      const map: Record<number, string> = { 0: 'error', 1: 'warning', 2: 'info' }
      return map[level] ?? 'info'
    }
  }
})
